// console.log(timestr(new Date(), 1)); // '2025-07-22 14:30:12'
// console.log(timestr('2025-01-01T08:30:00Z', 9, { convert_to_localtime: true }));
// console.log(timestr(new Date(), 4)); // 오늘이면 HH:MM, 아니면 YY-MM-DD

function timestr(time: any, time_format_mode = 1, { convert_to_localtime = false, convert_to_utc = false } = {}) {
  if (!time) return '';

  // 문자열이면 파싱
  if (typeof time === 'string') {
    time = new Date(time);
  }

  // 유효성 검사
  if (!(time instanceof Date) || isNaN(time.getTime())) return '';

  // UTC ↔ Local 변환
  if (convert_to_utc) {
    // force UTC (assumes current local time is input)
    time = new Date(time.getTime() - time.getTimezoneOffset() * 60000);
  } else if (convert_to_localtime) {
    time = new Date(time.getTime() + time.getTimezoneOffset() * 60000);
  }

  const now = new Date();
  const oneDayMs = 24 * 60 * 60 * 1000;

  // 날짜 비교용: "로컬 날짜" 비교
  const isDifferentDay = now.toDateString() !== time.toDateString();
  const isMoreThanOneDayAgo = (now.getTime() - time.getTime()) > oneDayMs;

  const pad = (n) => n.toString().padStart(2, '0');

  // 포맷터 정의
  const format = (fmt) => {
    const year = time.getFullYear();
    const month = pad(time.getMonth() + 1);
    const date = pad(time.getDate());
    const hours = pad(time.getHours());
    const minutes = pad(time.getMinutes());
    const seconds = pad(time.getSeconds());
    const ampm = time.getHours() >= 12 ? 'PM' : 'AM';
    const hour12 = pad(time.getHours() % 12 || 12);

    return fmt
      .replace('%Y', year)
      .replace('%y', year.toString().slice(2))
      .replace('%m', month)
      .replace('%d', date)
      .replace('%H', hours)
      .replace('%M', minutes)
      .replace('%S', seconds)
      .replace('%I', hour12)
      .replace('%p', ampm);
  };

  // 포맷 결정
  let fmt;
  switch (time_format_mode) {
    case 1: fmt = '%Y-%m-%d %H:%M:%S'; break;
    case 2: fmt = '%H:%M:%S'; break;
    case 3: fmt = '%Y-%m-%d'; break;
    case 4: fmt = isMoreThanOneDayAgo ? '%y-%m-%d' : '%H:%M'; break;
    case 5: fmt = '%Y%m%d'; break;
    case 6: fmt = '%Y%m'; break;
    case 7: fmt = isDifferentDay ? '%Y-%m-%d' : '%H:%M:%S'; break;
    case 8: fmt = '%Y-%m-%d %H:%M'; break;
    case 9: fmt = '%Y-%m-%d %I:%M %p'; break;
    default: fmt = '%Y-%m-%d';
  }

  return format(fmt);
}


export default { timestr };
